import {styled, alpha} from '@mui/material/styles';
import {Typography, InputBase} from '@mui/material';

export const ActionBar = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20
});

export const ActionItemStyled = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    width: '48%',
    padding: '10px 10px 20px 10px',
    borderRadius: 10,
    border: '1px solid #CAC4D0'
});

export const ActionTitleStyled = styled(Typography)({
    fontSize: 16
});

export const ActionTextStyled = styled(Typography)({
    fontSize: 12,
    color: '#49454F'
});

export const SelectedRowsTextStyled = styled(Typography)({
    fontSize: 14
});

export const FiltersContainer = styled('div')({
    display: 'flex',
    paddingBottom: 10,
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const FiltersWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'space-between'
});

export const Search = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #CAC4D0',
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    marginRight: theme.spacing(2),
    width: '100%'
}));

export const SearchIconWrapper = styled('div')(({theme}) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}));

export const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: 'black',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch'
        }
    }
}));
